import { useQuery } from '@tanstack/react-query';
import { fetchProjectConnectbaseTasks, projectConnectbaseTasksQueryKey } from '~/api/projectConnectbaseTasks';
import { useConnectbaseStatusMessagesEnabled } from '~/hooks/useConnectbaseStatusMessagesEnabled';
import { type ConnectbaseStatus, toConnectbaseStatus } from './status';

/**
 * The project's open ConnectBase task states, fetched when a component using it mounts and otherwise only when
 * refetched (the Utilities tab's agencies poll does); empty when the flag is off or the load fails.
 */
export function useConnectbaseStatus(projectId: string | undefined): {
  status: ConnectbaseStatus;
  isFetching: boolean;
} {
  const enabled = useConnectbaseStatusMessagesEnabled() && !!projectId;
  const { data, isFetching } = useQuery({
    queryKey: projectConnectbaseTasksQueryKey(projectId ?? ''),
    queryFn: () => fetchProjectConnectbaseTasks(projectId as string),
    enabled,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnMount: 'always',
    retry: false,
  });
  return { status: enabled ? toConnectbaseStatus(data) : {}, isFetching: enabled && isFetching };
}
